import jsPDF from "jspdf";
import { PdfElement } from "@src/app/interfaces/pdf.interface";

export class PdfImageElement implements PdfElement {
  private base64Image: string;
  public readonly newPage: boolean;

  constructor(base64Image: string, newPage: boolean = false) {
    this.base64Image = base64Image;
    this.newPage = newPage;
  }

  public async render(doc: jsPDF, x: number, y: number, maxWidth: number): Promise<number> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const originalWidth = img.width;
        const originalHeight = img.height;
        const aspectRatio = originalHeight / originalWidth;
        const renderWidth = maxWidth;
        const renderHeight = renderWidth * aspectRatio;
        let imageType = 'PNG';

        doc.addImage(this.base64Image, imageType, x, y, renderWidth, renderHeight);
        resolve(renderHeight);
      };

      img.onerror = (err) => {
        reject(err);
      };
      img.src = this.base64Image;
    });
  }

}
